import { EntityData } from '../../lib/types'

export default function sortResults(results: EntityData[], text: string): EntityData[] {
    const regexGenerator = `^${text.toLocaleLowerCase()}`
    const matchesStart = new RegExp(regexGenerator, 'i')
    const exactMatch = new RegExp(`^${text}$`, 'i')

    const priorities = results.map((r) => {
        let priority = 0
        const name = r.name.toLocaleLowerCase()

        if (exactMatch.test(name)) priority += 10

        const words = name.split(' ')
        for (let x = 0; x < words.length; x++) {
            if (matchesStart.test(words[x])) priority += 1
        }
        return {
            ...r,
            priority,
        }
    })

    priorities.sort((a, b) =>
        b.priority - a.priority === 0 ? a.id - b.id : b.priority - a.priority,
    )

    const output = priorities.map(({ priority, ...rest }) => rest)

    return output
}
